import React from 'react'
import './slide.css'



function Slide(props) {
    const {id, slideTitle, slideDescription, slideBg} = props
  return (
    <div className='slide' style={{backgroundImage:`url(${slideBg})`}}>
        <div className='backdrop'>
            <div className='text'>
                <h2>{slideTitle}</h2>
                <p>{slideDescription}</p>
            </div>
            <button className='learnMore'>
                Learn More
            </button>
        </div>
    </div>
  )
}

export default Slide